import React, { useEffect, useState } from "react";
import Service from "../Services/Service";

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const CustomMail = () => {
  const [templates, setTemplates] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridKey, setGridKey] = useState(0);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTemplates();
    loadVendors();
  }, []);

  useEffect(() => {
    const filtered = vendors.filter(
      (v) =>
        v.vendor?.toLowerCase().includes(searchText.toLowerCase()) ||
        v.email?.toLowerCase().includes(searchText.toLowerCase()),
    );

    setFilteredVendors(filtered);
  }, [searchText, vendors]);

  const loadTemplates = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Template");

      const res = await Service.getAll();

      setTemplates(res.data);
    } catch (err) {
      //console.error(err);
    }
  };

  const loadVendors = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Report");

      // const res = await Service.getAll();
      // console.log(res.data);

      // setVendors(res.data);
      // setFilteredVendors(res.data);

      const res = await Service.getAll();

      const vendorData = res.data.map((item, index) => ({
        ...item,
        id: index + 1,
      }));

      //console.log(vendorData);

      setVendors(vendorData);
      setFilteredVendors(vendorData);
    } catch (err) {
      //console.error(err);
    }
  };

  const handleSendMail = async () => {
    try {
      if (!selectedTemplate) {
        setSnackbar({
          open: true,
          message: "Please select template",
          severity: "warning",
        });
        return;
      }

      if (selectedRows.length === 0) {
        setSnackbar({
          open: true,
          message: "Please select vendor(s)",
          severity: "warning",
        });
        return;
      }

      //console.log("selectedRows", selectedRows);
      //console.log("vendors", vendors);

      const selectedVendorData = vendors.filter((v) =>
        selectedRows.includes(v.id),
      );

      const payload = {
        templateId: selectedTemplate,
        vendors: selectedVendorData.map((v) => ({
          vendorName: v.vendor,
          email: v.email,
        })),
      };

      //  ADD HERE
      //console.log("Selected Template:", selectedTemplate);
      //console.log("Selected Vendors:", selectedVendorData);
      //console.log("Payload:", payload);

      // SEND MAIL API
      setLoading(true);

      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/CustomMail");
      //debugger;
      const res = await Service.create(payload);
      setLoading(false);

      setSnackbar({
        open: true,
        message: res.data.message || "Mail Sent Successfully",
        severity: "success",
      });

      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);

      setSelectedRows([]);
      setSelectedTemplate("");
      setSearchText("");

      setGridKey((prev) => prev + 1);
    } catch (err) {
      setLoading(false);
      //console.error(err);

      setSnackbar({
        open: true,
        message: "Failed to send mail",
        severity: "error",
      });
    }
  };

  const columns = [
    {
      field: "vendor",
      headerName: "Vendor Name",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "contactNumber",
      headerName: "Contact",
      flex: 1,
    },
    {
      field: "station",
      headerName: "Station",
      flex: 1,
    },
    {
      field: "categoryGroup",
      headerName: "Category",
      flex: 1,
    },
  ];

  return (
    <div className="container mt-4">
      <Typography variant="h4" mb={3}>
        Custom Mail
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          flexWrap: "wrap",
        }}
      >
        <FormControl sx={{ minWidth: 250 }}>
          <InputLabel>Template Type</InputLabel>

          <Select
            value={selectedTemplate}
            label="Template Type"
            onChange={(e) => setSelectedTemplate(e.target.value)}
          >
            {templates.map((item) => (
              <MenuItem key={item.templateId} value={item.templateId}>
                {item.templateType}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Search Vendor"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ minWidth: 300 }}
        />

        <Button variant="contained" color="success" onClick={handleSendMail}>
          Send Mail
        </Button>
      </Box>

      <Box sx={{ height: 600, width: "100%" }}>
        {/* <DataGrid
         key={gridKey}
          rows={filteredVendors}
          columns={columns}
          checkboxSelection
          pageSizeOptions={[10, 25, 50]}
          getRowId={(row) => row.vendor} */}
        <DataGrid
          key={gridKey}
          rows={filteredVendors}
          columns={columns}
          checkboxSelection
          pageSizeOptions={[10, 25, 50]}
          onRowSelectionModelChange={(selectionModel) => {
            //console.log("Selected Rows:", selectionModel);

            const ids = Array.from(selectionModel.ids);

            setSelectedRows(ids);
          }}
        />
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() =>
          setSnackbar({
            ...snackbar,
            open: false,
          })
        }
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6">Sending Mail...</Typography>
      </Backdrop>
    </div>
  );
};

export default CustomMail;
